import PhoneInputPrimitive, { type Props as PhoneInputProps } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

import { cn } from '@/frontend/lib/utils'
import { inputStyles } from '@/frontend/components/ui/input'

/**
 * `react-phone-number-input` wrapper styled to match `<Input />`.
 * Emits E.164 strings via `onChange` (`undefined` when empty).
 *
 * `error` mirrors the `aria-invalid` styling on our other inputs. It's an
 * explicit prop rather than piggybacking on `aria-invalid` because the
 * library forwards that attribute to the inner `input`, not the wrapper.
 */
export function PhoneInput({
  className,
  onChange,
  error,
  ...props
}: PhoneInputProps<React.ComponentPropsWithoutRef<'input'>> & { error?: boolean }) {
  return (
    <PhoneInputPrimitive
      international
      defaultCountry="GB"
      onChange={onChange}
      {...props}
      className={cn(
        inputStyles,
        'flex h-8 w-full min-w-0 items-center gap-2 px-2.5 py-1',
        'focus-within:border-ring focus-within:ring-3 focus-within:ring-ring/50',
        'has-disabled:pointer-events-none has-disabled:cursor-not-allowed has-disabled:bg-input/50 has-disabled:opacity-50',
        error && 'border-destructive-fg ring-3 ring-destructive-border focus-within:border-destructive-fg focus-within:ring-destructive-border',
        '[&_.PhoneInputInput]:h-full [&_.PhoneInputInput]:flex-1 [&_.PhoneInputInput]:border-0 [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:text-inherit [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:placeholder:text-muted-foreground',
        '[&_.PhoneInputCountry]:flex [&_.PhoneInputCountry]:items-center [&_.PhoneInputCountry]:gap-1',
        '[&_.PhoneInputCountryIcon--border]:bg-transparent [&_.PhoneInputCountryIcon--border]:shadow-none',
        className
      )}
    />
  )
}
